import React, { useState } from "react";
import DataTable from "../../../../components/AdminTable/DataTable";

function LoyaltyPointsReport
() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },
    {
      header: "Customer Name",
      accessorKey: "Customer Name    ",
    },
    {
      header: "Phone",
      accessorKey: "Phone",
    }, {
      header: "Earned Points",
      accessorKey: "Earned Points",
    }, {
      header: "Spent Points",
      accessorKey: "Spent Points",
    }, {
      header: "Earned Points",
      accessorKey: "Earned Points",
    },
  ]);
  const [data] = useState([]);

  return (
    <main className="my-16">
      <div className="text-[#7B20C7] text-3xl text-center my-4">
      Loyalty Points Report
      </div>
      <span className="w-full bg-[#7B20C7] h-1 my-2 inline-block"></span>

      <DataTable columns={columns} data={data} />
    </main>
  );
}

export default LoyaltyPointsReport
;

